import { render, staticRenderFns } from "./onetalkConsultationDialog.vue?vue&type=template&id=68c44e4b&scoped=true"
import script from "./onetalkConsultationDialog.vue?vue&type=script&lang=js"
export * from "./onetalkConsultationDialog.vue?vue&type=script&lang=js"
import style0 from "./onetalkConsultationDialog.vue?vue&type=style&index=0&id=68c44e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c44e4b",
  null
  
)

export default component.exports